"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.divider .dotted {\n  width: 100%;\n  height: 2px;\n  background-image: url(\"data:image/svg+xml,%3csvg width='100%25' height='4' xmlns='http://www.w3.org/2000/svg'%3e%3cline x1='0' y1='2' x2='100%25' y2='2' stroke='black' stroke-width='4' stroke-dasharray='2%2c 8' stroke-linecap='butt'/%3e%3c/svg%3e\");\n  border-width: 0px;\n  margin-top: 0px; }\n";
  const fileName = "Divider_Divider";
  const element = document.querySelector("style[data-sass-component='Divider_Divider']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const Divider = _ref => {
  let {
    type
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "divider sia-margin-03-top sia-margin-03-bottom sia-margin-03-right divider"
  }, /*#__PURE__*/_react.default.createElement("hr", {
    className: type
  }));
};
Divider.propTypes = {
  type: _propTypes.default.string
};
Divider.defaultProps = {};
var _default = exports.default = Divider;